/** @format */

import { ApplicationRef, enableProdMode } from '@angular/core';
import { bootstrapApplication, enableDebugTools } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { chain } from '@core/chain';
import { environment } from './environments/environment';
import { startHoneycomb } from '@shared/ssr-core/data-access';

if (environment.production) {
	enableProdMode();
}

// Is Honeycomb enabled for the current chain?
if (environment.killSwitch.honeycombEnabled[chain.chainIdentifierAbbr]) {
	// Initialize Honeycomb
	startHoneycomb(
		environment.thirdParty.honeycomb.apiKey,
		environment.thirdParty.honeycomb.serviceName,
		'pdp',
		chain.chainIdentifierAbbr
	);
}

document.addEventListener('DOMContentLoaded', () => {
	bootstrapApplication(AppComponent, appConfig)
		.then((app) => {
			if (!environment.production) {
				const applicationRef = app.injector.get(ApplicationRef);
				const appComponent = applicationRef.components[0];
				enableDebugTools(appComponent);
			}
		})
		.then(() => {
			if (
				'serviceWorker' in navigator &&
				environment.production &&
				environment.killSwitch.serviceWorker[chain.chainIdentifierAbbr]
			) {
				navigator.serviceWorker.register(`./ngsw-worker.js`);
			}
		})
		.catch((error) =>
			console.error(
				`APPLICATION_ERROR:BOOTSTRAP_ERROR: ${JSON.stringify(error, ['message', 'arguments', 'type', 'name'])}`
			)
		);
});
